import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../../../components/Form/BackButton";
import { API, defaultLimitPagination, get } from "../../../config";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import { debounce } from "lodash";
import StatesActionButton from "./components/StatesActionButton";
import AddStates from "./AddStates";
import SearchBox from "../../common/SearchBox";

const States = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [statesList, setStatesList] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [showStates, setShowStates] = useState(false);

  // *API Call for Geting States - Start
  const fetchStates = useCallback(
    async (passLimit, passPage) => {
      try {
        setStatesLoading(true);
        const { data } = await get(
          `${API.GET_ADMIN_STATE_LIST}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }`
        );
        setStatesLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const holidayList = data?.data?.data;
        setStatesList(holidayList);
        return 0;
      } catch (error) {
        setStatesLoading(false);
        setStatesList([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField]
  );

  const statesModal = () => {
    fetchStates(limit, page);
  };

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);
  // *API Call for Geting States - End

  // *States Table Row and Column Generation, Filtering and Sorting of Record - Start
  const statesGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: statesList[i]?.id,
        id: statesList[i]?.id ? statesList[i]?.id : "",
        name: statesList[i]?.name ? statesList[i]?.name : "",
        short_name: statesList[i]?.short_name ? statesList[i]?.short_name : "",
        action: (
          <StatesActionButton
            id={statesList[i]?.id}
            statesModal={statesModal}
          />
        ),
      });
    }
    return items;
  };
  const statesData = statesGenerator(statesList?.length);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      // sort: true,
    },
    {
      dataField: "short_name",
      text: "Short Name",
      // sort: true,
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  // const onSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchParam(value);
  //   setPage(1);
  // };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchStates(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchStates(limit, page);
  };
  // *States Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    navigate(
      `/admin/states?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  const toggleStatesModal = () => {
    showStates && statesModal();
    setShowStates(!showStates);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      {" "}
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <h1 className="page-title">
              <BackButton />
              States
            </h1>
            <div className="content-details">
              <div className="table-top-btn">
                <SearchBox
                  placeholder={"Search States"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
                <div className="table-btn">
                  <Button variant="primary" onClick={toggleStatesModal}>
                    Add New
                  </Button>
                </div>
              </div>
              <div className="custom-table">
                {statesLoading && <Spin />}
                <BootstrapTable
                  keyField="states_id"
                  remote
                  data={statesData}
                  columns={columns}
                  onTableChange={handleTableChange}
                  noDataIndication="No Data Found"
                />
                <Pagination
                  total={total}
                  limit={parseInt(limit)}
                  currentPage={page}
                  updateLimit={handleUpdateLimit}
                  updatePage={handleChangePage}
                  from={from}
                  to={to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showStates && (
        <AddStates
          toggleStatesModal={toggleStatesModal}
          statesModal={statesModal}
          showStates={showStates}
        />
      )}
    </>
  );
};

export default States;
